import {useEffect} from 'react'
import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {useTranslation} from 'react-i18next'
import {useAppDispatch} from '../../../redux/hooks'
import {InactiveStudentAcc} from '../../../redux/Slice/generalSlice'
import {useParams} from 'react-router-dom'

export function InactiveStdAccount() {
  const {i18n} = useTranslation()
  const dispatch = useAppDispatch()
  const {id = ''} = useParams()
  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang)
    window.location.reload()
  }

  const languages = [
    {
      lang: 'fr',
      name: 'Français',
      flag: toAbsoluteUrl('/media/flags/france.svg'),
    },
    {
      lang: 'en',
      name: 'English',
      flag: toAbsoluteUrl('/media/flags/united-states.svg'),
    },
  ]

  const currentLanguage = languages.find((x) => x.lang === i18n.language)

  useEffect(() => {
    dispatch(InactiveStudentAcc(id))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className='card'>
        <div className='card-header bg-white border-bottom d-flex align-items-center justify-content-between'>
          <img src={toAbsoluteUrl('/media/logo/dakar-logo.png')} style={{maxWidth: '130px'}} />

          <div
            className='btn-group rounded-pill overflow-hidden'
            role='group'
            aria-label='Language selector'
          >
            {languages.map((language) => (
              <button
                key={language.lang}
                type='button'
                onClick={() => handleChangeLanguage(language.lang)}
                className={clsx(
                  'btn btn-sm px-2 py-1 d-flex align-items-center gap-1 fw-bold rounded-pill',
                  {
                    'btn-primary': i18n.language === language.lang,
                    'btn-outline-secondary': i18n.language !== language.lang,
                  }
                )}
              >
                <img
                  src={language.flag}
                  alt=''
                  width='22'
                  height='15'
                  className='rounded-pill object-fit-cover'
                />

                <span className='d-none d-sm-inline'>{language.name}</span>
              </button>
            ))}
          </div>
        </div>
        <div className='card-body p-5 p-md-9 text-center'>
          {currentLanguage?.lang === 'en' && (
            <>
              <span className='fa fa-circle-check text-success fs-1 mb-3'></span>

              <h3 className='fw-bold text-primary mb-3'>Your application has been closed.</h3>

              <p className='text-muted mb-0'>
                You have chosen not to continue your application to SWISS UMEF University – Dakar
                Campus. Your application process has therefore been closed.
              </p>
            </>
          )}

          {currentLanguage?.lang === 'fr' && (
            <>
              <span className='fa fa-circle-check text-success fs-1 mb-3'></span>

              <h3 className='fw-bold text-primary mb-3'>Votre candidature a été clôturée.</h3>

              <p className='text-muted mb-0'>
                Vous avez choisi de ne pas poursuivre votre candidature à SWISS UMEF University –
                Campus de Dakar. Votre processus de candidature a donc été clôturé.
              </p>
            </>
          )}
        </div>
      </div>
    </>
  )
}
